/*
 * @Date: 2021-11-20 17:43:12
 * @LastEditTime: 2023-08-21 18:14:12
 */
import { loadMicroApp, addGlobalUncaughtErrorHandler, prefetchApps } from 'qiankun'
import '@/utils/rem.ts'
import { appBaseUrl } from '@/config'

// let _microApp
export const initQiankun = info => {
  console.info('info:', info)
  console.time('initQiankun')
  Session.getToken(val => {
    // 针对拼装系统所需要传递的参数
    let __yk_cmp_skin_info__ = sessionStorage.getItem('__yk_cmp_skin_info__')
    let isInfo = __yk_cmp_skin_info__ && __yk_cmp_skin_info__ !== 'undefined'
    // console.log('_microApp:', window._microApp)
    // if (window._microApp) {
    //   return window._microApp.mount()
    // }
    window._microApp = loadMicroApp(
      {
        name: 'yk_cmp',
        // 相当于api - 指向项目即可
        entry: process.env.NODE_ENV === 'production' ? `${location.origin}/yk_cmp/` : 'http://localhost:3001',
        container: '#yk_cmp_container',
        props: {
          // 区分组件还是页面
          type: 'widget',
          // 模版唯一标识
          key: 'indexpage',
          // 可考虑配置化
          path: /(dbg.lizhiweike|localhost)/.test(location.origin)
            ? 'https://dbg.lizhiweike.com/yk_cmp/weikeIndexPage-708' // 测试环境链接，保底
            : `${appBaseUrl}/yk_cmp/weikeIndexPage-105`, // 正式环境链接，保底
          token: val.token,
          // token: Session.sessionData.token,
          // 判断是否有拉取到数据，如果没有 判断是否有sessionStorage，没有就返回undefined，让拼装系统内部处理path拉取数据逻辑
          info: info || (isInfo ? JSON.parse(__yk_cmp_skin_info__) : undefined)
        }
      }
      // { singular: false }, // 是否开启单实例
      // {
      //   afterMount: val => {
      //     console.log('afterMount:', val)
      //     console.timeEnd('initQiankun')
      //   },
      //   getStatus: val => {
      //     console.log('loadPromise:', val)
      //   }
      // }
    )
  })

  addGlobalUncaughtErrorHandler(event => {
    if (process.env.NODE_ENV === 'development') {
      // if (event.reason.message == 'Iframe has not been created yet.') {
      //   const iframe = document.getElementsByTagName('iframe')
      //   Object.values(iframe).forEach(res => res.src === '' && res.remove())
      //   console.log('刷新页面')
      // }
    }
    console.error('微应用错误：', event)
  })
}

export const prefetchQiankun = () => {
  try {
    prefetchApps([
      {
        name: 'yk_cmp',
        entry: process.env.NODE_ENV === 'production' ? `${location.origin}/yk_cmp/` : 'http://localhost:3001'
      }
    ])
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/qiankun.js